module.exports = new __parcel__URL__("jpd-matrix-blank.a2b06d63.svg").toString();